'use strict';

class Reports {
  constructor($location, $scope, $window, $sce, $filter, timeTrackingService, originatorService, I18N) {
    this.$location = $location;
    this.$scope = $scope;
    this.$window = $window;
    this.$sce = $sce;
    this.$filter = $filter;
    this.timeTrackingService = timeTrackingService;
    this.originatorService = originatorService;
    this.I18N = I18N;
  }

  $onInit() {
    this.alert = {};
    this.originator = {};
    this.international = false;

    this.params = {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().endOf('month').format('YYYY-MM-DD')
    };

    this.selectedClient = null;
    this.allSelected = 0;
    this.selectedEntries = [];

    this.report = [];

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });
  }

  selectClient(index) {
    this.selectedClient = this.report[index];
    this.selectedEntries = [];
    this.allSelected = false;
  }

  preview() {
    this.selectedClient = null;
    this.selectedEntries = [];
    this.timeTrackingService.getReport(this.params.from, this.params.to)
      .then((resp) => {
        this.report = resp.data;
      });
  }

  isSelected(entryNumber) {
    return this.selectedEntries.indexOf(entryNumber) !== -1;
  }

  sendInvoice() {
    this.timeTrackingService.saveInvoiceData({
      'entryNumbers': this.selectedEntries,
      'international': this.international
    }).then((resp) => {
      let invoiceDataNumber = resp.data;
      if (this.international) {
        this.$location.path('/regning/kladd/engelsk/ny').search({timetrack: invoiceDataNumber});
      } else {
        if (this.originator.giroLayout) {
          this.$location.path('/regning/kladd/ny').search({timetrack: invoiceDataNumber});
        } else {
          this.$location.path('/regning/kladd/utengiro/ny').search({timetrack: invoiceDataNumber});
        }
      }
    });
  }

  export() {
    if (this.selectedEntries.length === 0) {
      swal({
        title: 'Vennligst velg oppføringer',
        type: 'info',
        confirmButtonColor: '#004b8d',
        confirmButtonText: 'OK',
        allowOutsideClick: true
        // showCancelButton: true,
        // cancelButtonText: 'Avbryt'
      });
      return;
    } else {
      this.timeTrackingService.downloadXls(this.selectedEntries);
      // this.timeTrackingService.downloadXls({
      //   'entryNumbers': this.selectedEntries
      // });
      // .then((resp) => {
      // if (resp) {
      //   const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'rapport';
      //   const contentType = resp.headers()['content-type'];
      //
      //   saveAs(new Blob([resp.data], {
      //     type: contentType
      //   }), filename);
      // } else {
      //   return true;
      // }
      // });
    }
  }

  selectHandler(entryNumber) {
    var i = this.selectedEntries.indexOf(entryNumber);

    if (i !== -1) {
      this.selectedEntries.splice(i, 1);
    } else {
      this.selectedEntries.push(entryNumber);
    }
  }

  /**
   * Toggle selection of all items
   */
  toggleSelection() {
    if (this.allSelected) {
      this.selectedClient.projects.forEach((project) => {
        project.tasks.forEach((task) => {
          task.entries.forEach((entry) => {
            if (!this.isSelected(entry.number) && !entry.invoiceNumber) {
              this.selectedEntries.push(entry.number);
            }
          });
        });
      });
    } else {
      this.selectedClient.projects.forEach((project) => {
        project.tasks.forEach((task) => {
          task.entries.forEach((entry) => {
            let index = this.selectedEntries.indexOf(entry.number);
            if (index !== -1) {
              this.selectedEntries.splice(index, 1);
            }
          });
        });
      });
    }
  }
}

Reports.$inject = ['$location', '$scope', '$window', '$sce', '$filter', 'timeTrackingService', 'originatorService', 'I18N'];

const reports = {
  controller: Reports,
  templateUrl: 'time-track/invoice.html'
};

angular
  .module('SendRegning')
  .component('reports', reports)
  .config(($routeProvider) => {
    $routeProvider
      .when('/timeregistrering/regning', {
        title: 'Timeregistrering regning',
        template: '<reports />',
        secure: true
      });
  });
